import React, {useCallback} from 'react';
import { Field } from 'react-final-form';
import Grid from "@material-ui/core/Grid";
import { Trans } from "../../utils/i18n";
import RadioBigWithAmount from "../../Shared/RadioBigWithAmount";
import {hasProducts} from "../../config/orderEntryEnfore";
import {useFormState} from "../FormState";
import {getCookieValue} from "../../utils/getCookieValue";
import {useQuery} from "@tanstack/react-query";
import { useUpdateFormProducts } from '../../hooks/useUpdateFormProducts';

export const SelfRepairProductSelect = React.memo(function ({ problem_2, productValues, form, maxQuantity, hideProductDetailsButton = false, hideUnavailableContactLink = false }) {
        const orderEntryState = useFormState();
        const product = orderEntryState.selectedProduct?.id || orderEntryState?.serialNumber?.product?.id;
        const { addProduct, productExists, removeProduct, updateProduct, getProductFieldIndex } = useUpdateFormProducts({ form });

        const fetchFlow = useCallback(() => {
            return fetch(route('selfrepair.getFlow') + `?product_id=${product}${problem_2 ? `&problem_id=${problem_2}` : ''}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': getCookieValue('XSRF-TOKEN'),
                    'X-Requested-With': 'XMLHttpRequest',
                },
            })
                .then(response => response.json());
        }, [product, problem_2]);

        const { data, isLoading } = useQuery({
            queryKey: ['flows', product, problem_2],
            queryFn: fetchFlow
        });

        const products = orderEntryState?.selectedProducts?.length > 0 ? orderEntryState?.selectedProducts : data?.data?.products;

        return (
            <div>
                <h3>
                    <Trans i18nKey="orderEntry.productSelect.title">
                        You might need
                    </Trans>
                </h3>
                <Grid container spacing={3}>
                    {
                        products
                            ?.map((item, index) => {
                                const fieldIndex = getProductFieldIndex(item.id);

                                return (
                                    <Grid item xs={12} sm={4} key={item.id}>
                                        <Field
                                            name={`products[${fieldIndex}]`}
                                            type={'text'}
                                            //placeholder={field.placeholder}
                                            component={RadioBigWithAmount}
                                            validate={value => (hasProducts(productValues) ? undefined : <Trans i18nKey="productSelect.required">Required</Trans>)}
                                            field={{
                                                titel: item.description,
                                                description: item?.text,
                                                price: item.price,
                                                image: item.image,
                                                maxQuantity: Math.min(item?.stockQuantity ?? 0, maxQuantity ?? 99),
                                                hideProductDetailsButton,
                                                hideUnavailableContactLink,
                                            }}
                                            // RadioBigWithAmount is only interested in the amount value
                                            format={value => value?.amount}
                                            // In the form itself, we want to persist the item object with the amount in an array
                                            onChange={(amount) => {
                                                if (Number(amount) === 0) {
                                                    removeProduct(item.id)
                                                    return;
                                                }

                                                const isUpdate = productExists(item.id);

                                                if (isUpdate) {
                                                    updateProduct(item.id, { amount, type: "shop" });
                                                } else {
                                                    addProduct({
                                                        ...item,
                                                        amount,
                                                        type: "shop",
                                                    });
                                                }
                                            }}
                                        />
                                    </Grid>
                                )
                            })
                    }
                </Grid>
            </div>
        );
    },
    function areEqual(prevProps, nextProps) {
        return JSON.stringify(prevProps) === JSON.stringify(nextProps);
    });

